
/** Formats an ISO date as "9 October 2026" / "9 октомври 2026 г." (UTC, hydration-safe). */
export function formatReportDate(iso: string, isBg: boolean): string {
  const d = new Date(`${iso.slice(0, 10)}T00:00:00Z`);
  if (Number.isNaN(d.getTime())) return iso;
  return new Intl.DateTimeFormat(isBg ? "bg-BG" : "en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
    timeZone: "UTC",
  }).format(d);
}

export function ReportByline({
  isBg,
  name,
  role,
  photo,
  date,
}: {
  isBg: boolean;
  name?: string;
  role?: string;
  photo?: string;
  date?: string;
}) {
  if (!name && !role && !photo && !date) return null;
  return (
    <div className="mt-10 flex flex-wrap items-center gap-x-6 gap-y-3 border-t border-border/60 pt-6">
      {(name || role || photo) && (
        <div className="flex items-center gap-3">
          {photo && (
            <img src={photo} alt={name ?? ""} width={44} height={44} loading="lazy" className="h-11 w-11 rounded-full object-cover" />
          )}
          {(name || role) && (
            <div className="leading-tight">
              {name && <p className="text-[14.5px] font-medium text-foreground">{name}</p>}
              {role && <p className="mt-0.5 text-[13px] text-muted-foreground">{role}</p>}
            </div>
          )}
        </div>
      )}
      {date && (
        <p className="text-[13.5px] text-muted-foreground">
          <time dateTime={date.slice(0, 10)}>{formatReportDate(date, isBg)}</time>
        </p>
      )}
    </div>
  );
}

export function ReportMethodology({
  isBg,
  sampleSize,
  period,
  sources,
  text,
}: {
  isBg: boolean;
  sampleSize?: string;
  period?: string;
  sources?: string[];
  text?: string;
}) {
  const rows: [string, string][] = [];
  if (sampleSize) rows.push([isBg ? "Извадка" : "Sample size", sampleSize]);
  if (period) rows.push([isBg ? "Период" : "Period", period]);
  if (sources && sources.length) rows.push([isBg ? "Източници" : "Sources", sources.join(", ")]);
  if (!rows.length && !text) return null;
  return (
    <section aria-labelledby="methodology-heading" className="mt-12 rounded-2xl border border-border/60 bg-background p-6 shadow-[var(--shadow-soft)] sm:p-8">
      <h2 id="methodology-heading" className="font-display text-[1.1rem] font-medium text-foreground">
        {isBg ? "Методология" : "Methodology"}
      </h2>
      {rows.length > 0 && (
        <dl className="mt-4 grid gap-x-6 gap-y-3 text-[15px] sm:grid-cols-[max-content_1fr]">
          {rows.map(([k, v]) => (
            <div key={k} className="contents">
              <dt className="font-medium text-foreground">{k}</dt>
              <dd className="text-foreground/80">{v}</dd>
            </div>
          ))}
        </dl>
      )}
      {text && <p className="mt-4 text-[15px] leading-relaxed text-foreground/80">{text}</p>}
    </section>
  );
}
